import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { orderBy } from 'lodash/fp';
import { Loader, useFromToContext } from '../../shared';
import { useAuth } from '../../../utils/hooks/auth';
import { useVenueShiftsQuery } from '../../../generated/graphql';
import { LIMIT } from './constants';
import CashFlowListView from './CashFlowListView';

const CashFlowList = () => {
    const [offset, setOffset] = useState(0);
    const [shouldLoad, setShouldLoad] = useState(true);
    const { logout } = useAuth();
    const { dateFromTo } = useFromToContext();
    const {
        loading,
        error,
        data,
        fetchMore,
        called,
    } = useVenueShiftsQuery({ variables: { offset, limit: LIMIT, dateFromTo }, fetchPolicy: 'cache-first' });

    if (loading && called) {
        return (
            <Box display="flex" justifyContent='center' alignContent='center' flexGrow={1}>
                <Loader />
            </Box>
        );
    }

    if (error) {
        const authError = error.graphQLErrors[0]?.extensions?.exception?.status === 401;
        if (authError) {
            setTimeout(() => {
                // eslint-disable-next-line no-void
                void logout();
            }, 500);
        }

        return (
            <div>
                {error.message}
            </div>
        );
    }

    if (data) {
        const { venueShifts } = data;
        const sortedVenueShifts = orderBy('startedUtc', 'desc', venueShifts);

        const onLoadMore = async () => {
            if (shouldLoad) {
                const { data: fetchMoreResult } = await fetchMore({ variables: { offset, dateFromTo } });
                const { venueShifts: items } = fetchMoreResult;
                const dataLen = items.length;
                const newOffset = offset + LIMIT;
                setOffset(newOffset);
                if (dataLen % LIMIT !== 0 || dataLen === 0) {
                    setShouldLoad(false);
                }
            }
        };

        return (
            <CashFlowListView
                venueShifts={sortedVenueShifts}
                loadMore={onLoadMore}
                hasMore={shouldLoad}
            />
        );
    }

    return null;
};

export default CashFlowList;
